<template>
	<div id="app" v-if="device !== 'mobile'">
		<hud v-if="appFetched"></hud>
		<transitioner></transitioner>
		<transition v-if="appFetched" mode="out-in" :css="false" v-on:enter="onSectionEnter" v-on:leave="onSectionLeave" appear>
			<router-view ref="view"></router-view>
		</transition>
	</div>
	<mobile-soon v-else></mobile-soon>
</template>

<script>
// vuex
import { mapGetters } from 'vuex'

// resize
import debounce from 'lodash/debounce'
import { getResponsiveTag } from '@/utils'

// import components
import Hud from '@/components/Hud'
import Transitioner from '@/components/Transitioner'
import Smooth from '@/vendors/smooth.js'
import analytics from '@/core/analytics'

// lazyload
const MobileSoon = () => import('@/components/MobileSoon.vue'/* webpackChunkName: "mobile" */)

export default {
	name: 'App',
	components: {
		'hud': Hud,
		'transitioner': Transitioner,
		'mobile-soon': MobileSoon
	},
	computed: {
		...mapGetters({
			appFetched: 'fetched',
			device: 'device'
		})
	},
	data () {
		return {
			glitter: null
		}
	},
	methods: {
		save: function () {
			this.$store.dispatch('saveSize', {
				width: window.innerWidth,
				height: window.innerHeight,
				device: getResponsiveTag()
			})
		},
		onSectionEnter: function (el, done) {
			this.smoothInit()
			if (this.$refs.view.onSectionEnter) this.$refs.view.onSectionEnter(el, done)
			else done()
		},
		onSectionLeave: function (el, done) {
			this.smoothDestroy()
			if (this.$refs.view.onSectionLeave) this.$refs.view.onSectionLeave(el, done)
			else done()
		},
		smoothInit () {
			// no glitter effect is defined, exist
			if (!this.$refs.view.glitter) return

			let self = this
			let glitter = this.$refs.view.glitter

			// if a glitter effect is defined try to request it
			// if exist inject json settings to smooth
			import(
				/* webpackChunkName: "glitter/[request]" */
				`./glitter/${glitter}`
			).then((g) => {
				// instanciate smooth scroll instance
				self.smooth.init()
				self.smooth.addElements(JSON.parse(JSON.stringify(g)))
				self.smooth.start()
			})
		},
		smoothDestroy () {
			this.smooth.destroy()
		}
	},
	created: function () {
		// save current screen size
		this.save()
		// bind a debounced resize event
		window.addEventListener('resize', debounce(this.save, 500), false)
		// create smooth instance
		this.smooth = new Smooth({ smoothContainer: false })
		// load analytics
		analytics.load(process.env.UA)
	},
	mounted () {
		this.$bus.$emit('transitioner:show')
		this.$store.dispatch('fetchData')
	}
}
</script>

<style src="@/styles/index.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/App.vue